import {useState, useEffect, FunctionComponent} from 'react';

import localAuth from 'model/auth/AuthStore';

import { Stack, Container, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2'

import NotificationList from "components/notification/NotificationList";

import { Loading } from 'components/common/Loading';
import SendIcon from '@mui/icons-material/Send';
import { useApi } from 'hooks/useApi';
import { NotificationModel } from 'model/notification/NotificationModels';
import { BACKEND_ENDPOINT } from 'utils/Common';
import { ErrorContainer } from 'components/common/ErrorContainer';

const Notifications: FunctionComponent = () => {
  const { request, loading, error } = useApi();
  const accessToken: string = localAuth((state) => state.authToken);

  const [notifications, setNotifications] = useState([]);
  
    useEffect(() => {
      const loadNotifications = async () => {
        try {
          const data = await request<NotificationModel[]>(() => 
            fetch(BACKEND_ENDPOINT + "notification", {
              headers: {
                'Content-Type': 'application/json', 
                'Accept': 'application/json', 
                'Authorization': `Bearer ${accessToken}`
              }
            })
          );
          setNotifications(data);
        } catch (error) {
          console.error("Failed to fetch notifications:", error);
        }
      };
      
      loadNotifications();
    }, [accessToken]);

  if (loading) {
    return (
      <Container maxWidth="md">
        <Stack spacing={1}>
          <Loading toolbarLoading={<div style={{paddingLeft: "16px", paddingTop: "20px"}}>
            <Grid container>
              <Grid display="flex" alignItems="center">
                <Typography variant='h6'><SendIcon style={{marginRight: "10px"}} className='toolbar-mui-icon'/>NOTIFICATIONS</Typography>
              </Grid>
              <Grid size="grow"></Grid>
            </Grid></div>} variant='walker' height='71.33px'/>
          <Loading variant='walker' height='390px'/>
        </Stack>
      </Container>
    )
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Stack spacing={1}>
          <ErrorContainer errorToolbar={<div style={{paddingLeft: "16px", paddingTop: "20px"}}>
            <Grid container>
              <Grid display="flex" alignItems="center">
                <Typography variant='h6'><SendIcon style={{marginRight: "10px"}} className='toolbar-mui-icon'/>NOTIFICATIONS</Typography>
              </Grid>
              <Grid size="grow"></Grid>
            </Grid></div>} height='71.33px'/>
          <ErrorContainer text='An error occured while trying to fetch the notifications. Please try again later.' height='390px'/>
        </Stack>
      </Container>
    )
  }

  return (
    <Container maxWidth="md">
      <NotificationList notifications={notifications}/>
    </Container>
  );
};

export default Notifications;
